var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{staticClass:"content-main order-lg-2",attrs:{"lg":"8","md":"12"}},[_c('UnternehmenFilters'),_c('UnternehmenList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }